<app-activity-indicator />
<app-confirm-dialog />
<app-toast-container />
<router-outlet />
